import React from 'react';
import I18n from '../../../config/i18n';

import './reviews.css';

export default function ReviewsSuccess() {
  return (
    <div className="container reviews__container">
      <div className="row">
        <div className="col-lg-2 col-md-1" />
        <div className="col col-lg-8 col-md-10">
          <div className="reviews-body-col">
            <h1 className="reviews-title">{I18n.t('reviews.success_title')}</h1>
            <p>{I18n.t('reviews.thank_you')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
